export const mirrorFetch = async (url: string) => {
  const body = new FormData()
  body.append('url', url)
  const res = await fetch(`${window.envVariables.REACT_APP_BASE_URL + '/api/mirror/'}`, {
    method: 'POST',
    body,
  })
  const json = await res.json()
  return json
}
